import styled from "styled-components";

export const StyleScreenWidthLarger = (
	setHeight?: number,
	setMaxHeight?: number,
	isMaxContent?: boolean,
) => ({
	content: {
		margin: "auto",
		borderRadius: 5,
		padding: "0 0",
		width: 700,
		fontFamily:
			"Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
		height: setHeight
			? `${setHeight}px`
			: isMaxContent
			? "max-content"
			: "",
		maxHeight: setMaxHeight ? `${setMaxHeight}px` : "",
	},
	overlay: {
		zIndex: 1000000,
	},
});

export const StyleScreenWidthDefault = {
	content: {
		margin: "auto",
		borderRadius: 0,
		padding: "0 0",
		width: "100%",
		left: "0%",
		top: "40px",
		fontFamily:
			"Roboto, Nunito, Arial, Helvetica, sans-serif, Arial, sans-serif",
		height: "100dvh",
	},
	overlay: {
		zIndex: 1000000,
	},
};

export const AGButton = styled.button`
	border-radius: 5px;
	border-radius: 5px;
	font-size: 1.07692rem;
	font-weight: 600;
	letter-spacing: 0px;
	opacity: 1;
	font-size: 0.875rem;
	width: auto;
	min-width: 50px;
	padding: 5px 15px;
	margin: 10px 10px 10px 0;
	&:hover,
	&:focus {
		background-color: rgb(218, 218, 218);
	}
	&.btn-cancel {
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
		height: 100%;
		justify-content: center;
		vertical-align: baseline;
		width: 178px;
		height: 38px;
		color: black;
		margin-top: 20px;
		margin-bottom: 20px;
		background: #d9d9d9;

		&:hover {
			background: #a8a8a8;
		}
	}
`;

export const ModalHeader = styled.div<{ height?: number }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: ${({ height }) => (height ? `${height}px` : "60px")};
	border-bottom: 1px solid #cccccc;
	padding: 0px 20px;
	.title {
		font-size: 1rem;
		font-weight: 700;
	}
	.tool-tip {
      font-size: 0.875rem !important;
      font-weight: 400;
      max-width: 300px;
      a {
        font-weight: 700 !important;
      }
    }
`;

export const ModalBody = styled.div`
	/* display: flex; */
	align-items: center;
	justify-content: space-between;
	.title {
		font-size: 1rem;
		font-weight: 700;
	}
	overflow-y: auto;
	position: relative;
	min-height: calc(100% - 120px);
	width: 100%;
`;

// export const ModalBodyAddProfile = styled.div`
// 	display: flex;
// 	align-items: center;
// 	justify-content: space-between;
// 	.title {
// 		font-size: 18px;
// 		font-weight: 700;
// 	}
// 	overflow-y: scroll;
// 	position: relative;
// 	height: 300px;
// 	width: 100%;
// `;

export const ModalFooter = styled.div`
	border-top: 1px solid #cccccc;
	padding: 0px 20px;
	display: flex;
	align-items: center;
	@media screen and (min-width: 769px) {
		justify-content: end;
	}
	@media only screen and (max-width: 768px) {
		justify-content: center;
	}
	@media only screen and (max-width: 1024px) and (max-height: 430px) {
		justify-content: center;
	}
	gap: 10px;
	height: 60px;
	touch-action: none !important;
`;

export const CloseIconWraper = styled.div`
	&:hover {
		opacity: 0.9;
		cursor: pointer;
	}
`;
